export const getLocationHash = (): string => {
  return location.hash.replace(/^#/, '');
};
